export function reportingPermissionToNum(permission: string): number {
    let mapper = {
          'low': 1,
          'medium': 2,
          'full': 3
        };
    return mapper[permission] || 0;
}
